import React from 'react';

import classes from '../installPics.css';

import Image from '../../../../../../../assets/CarportDiagram.jpg';

const CorrugatedPic1
 = () => (
     <div className={classes.installImages}>
         <img alt="Carport Diagram" src={Image} className={classes.installImg} />
     </div>
 );


export default CorrugatedPic1;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Carport/CarportImg1.js